import React from 'react';
import { Container, Flex, Heading, Link, Text } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';

const linksData = [
  {
    id: 'Standard_PPM_Audit_Format',
    date: '24th September 2024',
    text: 'Frequently Asked Questions on Standardised SEBI PPM Audit Format',
    link: 'https://static.levocdn.com/WGLBUT82/FAQs-StandardizationofPPMAuditReport-CISgOrOHJX6qs.pdf',
    // click: 'download',
  },
  {
    id: 'Standard_PPM_Audit_Format',
    date: '17th September 2024',
    text: 'IVCA Webinar: Understanding the Standardised SEBI PPM Audit Format',
    link: 'https://youtu.be/bzgmac26F2E',
    // click: 'download',
  },
  {
    id: 'Standard_PPM_Audit_Format',
    date: '18th April 2024',
    text: 'Standard PPM Audit Format',
    link: 'https://static.levocdn.com/WGLBUT82/PPMauditformatrevised120424-wGfpJvXctJ3s.xlsx',
    click: 'download',
  },
  {
    id: 'Circular_Standard_PPM_Audit_Format',
    date: '18th April 2024',
    text: 'SEBI Circular on Standardisation of the PPM Audit Format',
    link: 'https://static.levocdn.com/WGLBUT82/AIFCircularPPMAuditStandardization-DcP1s07daVGy.pdf',
  },
];

const StandardPpmAuditFormat = () => {
  const handleDownloadFile = (filePath: string) => {
    let link = document.createElement('a');
    link.href = filePath;
    link.download = filePath.slice(filePath.lastIndexOf('/') + 1);
    link.click();
  };

  return (
    <Flex direction="column" rowGap="20px">
      <MemberHeroSection
        title={
          <Heading
            as="h1"
            variant="headingText"
            color="text.headingWhite"
            fontSize={{ xs: '36px', sm: '60px', md: '74px' }}
            textAlign={{ xs: 'left', sm: 'left' }}
          >
            Standardised Private Placement Memorandum(PPM) Audit Format
          </Heading>
        }
        type="about-us"
      />
      <Container
        maxW="container.xl"
        pt={{ xs: '50px', md: '50px' }}
        pb={{ xs: '50px', md: '50px' }}
        as="section"
        id="info"
        scrollMarginTop="140px"
      >
        <Flex direction="column" gap="2">
          {linksData.map((item) => (
            <Flex
              key={item.id}
              direction={{ base: 'column', md: 'row' }}
              cursor="pointer"
              gap={{ md: '5' }}
              onClick={() => {
                if (item.click === 'download') {
                  handleDownloadFile(item.link);
                } else {
                  window.open(item?.link, '_blank');
                }
              }}
            >
              <Flex minWidth="200px">
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.date}
                </Text>
                <Text
                  display={{ base: 'block', md: 'none' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
              </Flex>
              <Flex>
                <Text
                  display={{ base: 'none', md: 'block' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item.text}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Container>
    </Flex>
  );
};

export default StandardPpmAuditFormat;
